

import { buildAdministrative } from "./administrative";
import { buildAreaAdmin } from "./area-admin";
import { buildClasses } from "./classes";
import { buildCoordinatorAdmin } from "./coordinator-admin";
import { permissionCheck } from "./permission-check";
import { buildProgramAdmin } from "./program-admin";
import { buildRegionAdmin } from "./region-admin";
import { buildStudents } from "./students";

const defaultFunc = () => {};
export const buildRootItems = ({navigation, strings, permissions = [],
  flags = [], onClick = defaultFunc,
  unreadCount}) => {


  let homeUrl = ``;
  if (navigation.area) {
    homeUrl = `${homeUrl}/areas/${navigation.area.id}`;
  }
  if (navigation.program) {
    //if we have a program, we have to solve na for region and coordinator both
    homeUrl = navigation.region
      ? `${homeUrl}/regions/${navigation.region.id}`
      : `${homeUrl}/regions/na`;
    homeUrl = navigation.coordinator
      ? `${homeUrl}/coordinators/${navigation.coordinator.id}`
      : `${homeUrl}/coordinators/na`;
    homeUrl = `${homeUrl}/programs/${navigation.program.id}`;
    if (navigation.term) {
      homeUrl = `${homeUrl}/years/${navigation.year.id}/terms/${navigation.term.id}`;
    }
  } else if (navigation.coordinator) {
    //if we have a coordinator, we need to solve out the region piece
    homeUrl = navigation.region
      ? `${homeUrl}/regions/${navigation.region.id}`
      : `${homeUrl}/regions/na`;
    homeUrl = `${homeUrl}/coordinators/${navigation.coordinator.id}`;
  } else if (navigation.region) {
    homeUrl = `${homeUrl}/regions/${navigation.region.id}`;
  }

  const items = [
    {
      id:21,
      type: "link",
      label: strings.home,
      "data-id": "accordion-home",
      href: homeUrl,
      onClick: (e) => {onClick({
        event:e,
        href:homeUrl,
        isHome:true
      })}
    },
  ];

  if (
    permissionCheck(navigation, "readAreaAdministration") &&
    navigation.area &&
    !navigation.region &&
    !navigation.program &&
    !navigation.coordinator
  ) {
    items.push(buildAreaAdmin(navigation, strings, permissions, onClick, flags));
  } else if (
    permissionCheck(navigation, "readRegionAdministration") &&
    navigation.region &&
    !navigation.coordinator &&
    !navigation.program
  ) {
    items.push(buildRegionAdmin(navigation, strings, permissions, onClick, flags));
  } else if (
    permissionCheck(navigation, "readRegionAdministration") &&
    navigation.coordinator &&
    !navigation.program
  ) {
    items.push(buildCoordinatorAdmin(navigation, strings, permissions, onClick, flags));
  } else if (
    permissionCheck(navigation, "readProgramAdministration") &&
    navigation.program
  ) {
    items.push(buildProgramAdmin(navigation, strings, permissions, onClick));
  }

  //you have to be at a term for this
  if (navigation.term) {
    const classes = buildClasses(navigation, strings, permissions, onClick);
    if (classes) {
      items.push(classes);
    }
    const students = buildStudents(navigation, strings, permissions, onClick);
    if (students) {
      items.push(students);
    }
  }

  const administrative = buildAdministrative(navigation, strings, permissions, onClick, flags);
  if (administrative) {
    items.push(administrative);
  }

  const isSucceedInSchool = navigation.program?.programType === "sis";

  //placeholder to let QA verify that feature flags are getting through to the app.
  if (flags.indexOf("qa-feature-flag") >= 0) {
    items.push(
      {
        id:22,
        type: "link",
        label: "QA Feature",
        "data-id": "qa-feature-flag-link",
        href: "https://www.google.com",
      },
    )
  }
  if (navigation.program && !isSucceedInSchool) {
    items.push({
      id:23,
      type:"link",
      label:strings.messaging,
      "data-id":"messaging-link",
      href:`${homeUrl}/messaging`,
      onClick: (e) => {
        onClick({
          event:e,
          href:`${homeUrl}/messaging`,
          isHome:false
        })},
      count:unreadCount
    });
  }



  return items;
};
